import ActionButton from '@repo/ui/action-button'
import { ClockwiseIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { getSimilarEnrollments } from '../../../../api/enrollments/get-similar-enrollments'
import { useModalManager } from '../../../../lib/hooks/use-modal-manager'
import { ApplicationStatusEnum } from '../../../../lib/types/enums/enrollment/application-status.enum'
import { EnrollmentDetailsView, filterEnrollmentsByStatus } from '../enrollment-history-view'

type Props = {
  enrollmentId: number
}

const EnrollmentTripHistoryButton = ({ enrollmentId }: Props) => {
  const { modalState, toggleModal, closeModel } = useModalManager<'trips-history'>([
    'trips-history'
  ])

  const { data: similarEnrollments } = useQuery({
    queryKey: ['similar-enrollments', enrollmentId],
    queryFn: () => getSimilarEnrollments(enrollmentId)
  })

  const { confirmedSimilarEnrollments, enrollingSimilarEnrollments, hasSomeSimilarEnrollments } =
    useMemo(() => {
      const confirmedSimilarEnrollments = filterEnrollmentsByStatus(
        ApplicationStatusEnum.CONFIRMED,
        similarEnrollments
      )

      const enrollingSimilarEnrollments = filterEnrollmentsByStatus(
        ApplicationStatusEnum.TO_BE_CONTACTED,
        similarEnrollments
      )

      const hasSomeSimilarEnrollments =
        (confirmedSimilarEnrollments && confirmedSimilarEnrollments.length > 0) ||
        (enrollingSimilarEnrollments && enrollingSimilarEnrollments.length > 0)

      return {
        confirmedSimilarEnrollments,
        enrollingSimilarEnrollments,
        hasSomeSimilarEnrollments
      }
    }, [similarEnrollments])

  return (
    <>
      {hasSomeSimilarEnrollments && (
        <ActionButton
          icon={ClockwiseIcon}
          variant={'lightPurple'}
          tooltipText={"Historique des bulletins d'inscription"}
          onClick={() => toggleModal('trips-history')}
        />
      )}

      {/* trip history modal */}
      <Modal
        icon={ClockwiseIcon}
        size={'medium'}
        isOpen={modalState['trips-history']}
        onCancel={() => closeModel('trips-history')}
        title={"Historique des bulletins d'inscription"}
      >
        <EnrollmentDetailsView
          mode={'trip'}
          sections={[
            { title: 'Séjours déjà effectués', data: confirmedSimilarEnrollments },
            { title: 'Séjours à venir', data: enrollingSimilarEnrollments }
          ]}
        />
      </Modal>
    </>
  )
}

export default EnrollmentTripHistoryButton
